import { styled } from '@mui/material';
import Box from '@mui/material/Box';

/**
 * Wrapper for the page content; creates essential padding and spacing boundaries within PageWrapper
 */
const ContentWrapper = styled(Box)(({ theme }) => ({
	margin: '0 auto',
	maxWidth: 'none',
	padding: '1em',
	paddingTop: '1.5em',
	paddingBottom: '1.5em',
	[theme.breakpoints.up('sm')]: {
		paddingTop: '2.5em',
		paddingBottom: '2.5em',
		maxWidth: '500px',
	},
}));

export default ContentWrapper;
